// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"199":"8a72d3d0","453":"70b44f9b","459":"02ca8a33","755":"3ba05aff","984":"7cea7767"}[chunkId] + ".chunk.js";
};